import { render, staticRenderFns } from "./IconButtonClose.vue?vue&type=template&id=39befce8&scoped=true&"
import script from "./IconButtonClose.vue?vue&type=script&lang=js&"
export * from "./IconButtonClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39befce8",
  null
  
)

export default component.exports